// extracted by mini-css-extract-plugin
export default {"cta":"EF-z","disabled":"FF-z"};